enum PopoverPosition {
  Above,
  Below,
  Left,
  Right,
  Cover,
}

export default PopoverPosition;
